import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Clients = () => {
  const testimonials = [
    {
      name: 'Miguel Ángel Rguez.',
      position: 'CEO',
      company: 'Centro Médico La Cuesta',
      testimonial: 'VGBComputers transformó nuestra infraestructura IT, mejorando significativamente nuestra productividad.',
      icon: FiIcons.FiAward
    },
    {
      name: 'Fernando Trujillo',
      position: 'Gerente',
      company: 'Tránsitos Trujillo',
      testimonial: 'Su servicio de mantenimiento preventivo nos ha ahorrado tiempo y dinero en resolución de problemas.',
      icon: FiIcons.FiThumbsUp
    }
  ];

  const cases = [
    {
      title: 'Modernización de Infraestructura',
      description: 'Implementamos una solución completa de virtualización y backup que redujo los costes operativos en un 40%.',
      icon: FiIcons.FiServer
    },
    {
      title: 'Seguridad Empresarial',
      description: 'Sistema integral de ciberseguridad que protege los datos sensibles y cumple con la normativa GDPR.',
      icon: FiIcons.FiShield
    }
  ];

  return (
    <div className="py-16 relative">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12">Nuestros Clientes</h1>

        {/* Casos de Éxito */}
        <section className="mb-16">
          <h2 className="text-2xl font-semibold mb-8">Casos de Éxito</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {cases.map((case_, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg p-6">
                <SafeIcon icon={case_.icon} className="h-12 w-12 text-blue-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">{case_.title}</h3>
                <p className="text-gray-600 text-justify">{case_.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Testimonios */}
        <section>
          <h2 className="text-2xl font-semibold mb-8">Testimonios</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6">
                <SafeIcon icon={testimonial.icon} className="h-8 w-8 text-blue-600 mb-4" />
                <p className="text-gray-600 italic mb-4 text-justify">{testimonial.testimonial}</p>
                <div>
                  <p className="font-semibold">{testimonial.name}</p>
                  <p className="text-gray-500">{testimonial.position}, {testimonial.company}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* Botón para volver arriba */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all z-50"
        aria-label="Volver arriba"
      >
        <SafeIcon icon={FiIcons.FiArrowUp} className="h-6 w-6" />
      </button>
    </div>
  );
};

export default Clients;